"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageRequestDTOSchema = exports.MessageDTO = exports.MessageSchema = exports.MessageBaseSchema = void 0;
var zod_1 = require("zod");
var ObjectId_1 = require("./lib/ObjectId");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var User_1 = require("./User");
exports.MessageBaseSchema = zod_1.z.object({
    sender: zod_1.z.instanceof(ObjectId_1.ObjectId),
    receiver: zod_1.z.instanceof(ObjectId_1.ObjectId),
    message: zod_1.z.string(),
    seen: zod_1.z.boolean().default(false),
});
exports.MessageSchema = exports.MessageBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var MessageDTOSchema = exports.MessageSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.MessageDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            message: model.message,
            seen: model.seen,
            sender: (0, ObjectId_1.isPopulated)(model.sender) ? User_1.UserDTO.convertFromModel(model.sender) : model.sender.toString(),
            receiver: (0, ObjectId_1.isPopulated)(model.receiver)
                ? User_1.UserDTO.convertFromModel(model.receiver)
                : model.receiver.toString(),
        };
        return dto;
    },
};
exports.MessageRequestDTOSchema = MessageDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { sender: (0, ObjectId_1.ObjectIdString)('Invalid sender id'), receiver: (0, ObjectId_1.ObjectIdString)('Invalid receiver id') }));
//# sourceMappingURL=Message.js.map